const maintenancesStatusLabel = {
  title: 'En Proceso',
  title1: 'Cancelada',
  title2: 'Concluida',
  title3: 'Programada',
  title4: 'Pendiente',
  title5: 'Vencida',
  title6: 'En Retraso',
};

export default maintenancesStatusLabel;